export enum TAdminPageTab {
  ProgramCodes,
  Organizations,
  ImportMedications,
  GlobalMessages,
}
